import { Component, OnInit, Inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { ChangeLinkAction } from "../links.actions";
import { wyswigConfig } from "../../../signatures/signatures.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../../shared/error-state-matcher";

@Component({
  selector: "app-link-edit",
  templateUrl: "./link-edit.component.html",
  styleUrls: ["./link-edit.component.scss"],
  standalone: false,
})
export class LinkEditComponent implements OnInit {
  config = wyswigConfig;
  file;
  form: UntypedFormGroup;
  saving = false;
  editMode = true;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<LinkEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      link?: { addonId: string; name: string; url: string; text: string };
    },
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    const linkData = this.data?.link || {
      addonId: "",
      name: "",
      url: "",
      text: "",
    };
    this.form = new UntypedFormGroup({
      addonId: new UntypedFormControl(linkData.addonId, (c) =>
        Validators.required(c),
      ),
      name: new UntypedFormControl(linkData.name || "", (c) =>
        Validators.required(c),
      ),
      url: new UntypedFormControl(linkData.url || "", (c) =>
        Validators.required(c),
      ),
      text: new UntypedFormControl(linkData.text || "", (c) =>
        Validators.required(c),
      ),
    });
  };

  onSubmit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.saving || this.form.invalid) {
      return;
    }
    this.saving = true;
    this.store.dispatch(
      new ChangeLinkAction(
        this.form.value as {
          addonId: string;
          name: string;
          url: string;
          text: string;
        },
      ),
    );
    this.dialogRef.close(true);
  };

  cancel = () => {
    this.fillInitialForm();
    this.dialogRef.close();
  };
}
